import { InputPeriod, MachinesReport } from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';

export const MACHINE_DASHBOARD_WIDGET_IDS = [
  'dataStatus',
  'geofencing',
  'batteryStatus',
  'machineUtilisation',
] as const;

export type MachineDashboardWidgetId = (typeof MACHINE_DASHBOARD_WIDGET_IDS)[number];

/** KPIs that ignore the date filter — do not refetch/reload when only period changes. */
export const PERIOD_INDEPENDENT_MACHINE_DASHBOARD_WIDGET_IDS = [
  'dataStatus',
  'geofencing',
  'batteryStatus',
] as const satisfies readonly MachineDashboardWidgetId[];

export const PERIOD_DEPENDENT_MACHINE_DASHBOARD_WIDGET_IDS = [
  'machineUtilisation',
] as const satisfies readonly MachineDashboardWidgetId[];

export interface MachineDashboardWidgetListRequestContext {
  period: InputPeriod;
  siteIds: string[] | undefined;
  machineIds: string[] | undefined;
}

export interface IWidgetMachineListState {
  machines: MachinesReport[];
  thumbnailUrlsByMachineId: Record<string, string>;
  isLoading: boolean;
  isLoadingMore: boolean;
  nextPaginationToken: string;
  hasMore: boolean;
  requestContext: MachineDashboardWidgetListRequestContext | null;
}

export type IWidgetMachineListsState = Record<MachineDashboardWidgetId, IWidgetMachineListState>;

export const createInitialWidgetMachineListState = (): IWidgetMachineListState => ({
  machines: [],
  thumbnailUrlsByMachineId: {},
  isLoading: false,
  isLoadingMore: false,
  nextPaginationToken: '',
  hasMore: false,
  requestContext: null,
});
